import axios from 'axios'
const headers = { headers: { 'x-api-version': '1.0' } }
export const getCustomtext = (id: string) => {
  return axios.get(
    axios.defaults.baseURL + 'customtext/bbltexts/Landingsside/' + id,
    headers
  )
}
